module.exports = __webpack_public_path__ + "img/JAVA.c0b8c1f6.png";